import APIConnector from './utils/APIConnector';

const Request = APIConnector.instance;

class NavigationAPI {
  static getNavigationEntity = () => Request.GET('/merchant/nav');
}

export default NavigationAPI;
